import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/PageHeader";
import { api, errMsg, slug } from "@/lib/api";
import { classeFoto, publicFile } from "@/components/landing/LandingData";

const FIELDS = [
  ["lunghezza", "Lunghezza fuori tutto"], ["larghezza", "Larghezza"], ["peso", "Peso"],
  ["randa_fiocco", "Randa e fiocco"], ["spinnaker", "Spinnaker asimmetrico"], ["equipaggio", "Equipaggio"],
];

const ClasseForm = ({ classe }) => {
  const [f, setF] = useState(classe);
  const s = slug(classe.categoria);
  const save = async () => {
    try {
      const payload = Object.fromEntries(["descrizione", ...FIELDS.map(([k]) => k)].map((k) => [k, f[k] || ""]));
      setF((await api.put(`/admin/classi/${encodeURIComponent(classe.categoria)}`, payload)).data);
      toast.success(`${classe.categoria} salvata`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const upload = async (file, tipo = "scheda") => {
    if (!file) return;
    const fd = new FormData();
    fd.append("foto", file);
    try {
      setF((await api.post(`/admin/classi/${encodeURIComponent(classe.categoria)}/foto`, fd, { params: { tipo } })).data);
      toast.success(tipo === "home" ? "Immagine Home aggiornata" : "Foto aggiornata");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Panel data-testid={`classe-admin-${s}`}>
      <div className="grid md:grid-cols-[220px_1fr] gap-6">
        <div>
          <img src={classeFoto(f)} alt={f.categoria} className="w-full aspect-[16/10] object-cover rounded-lg bg-slate-100" />
          <Label className="text-xs mt-2 block">Foto scheda (JPG/PNG/WEBP, max 5 MB)</Label>
          <Input type="file" accept=".jpg,.jpeg,.png,.webp" onChange={(e) => upload(e.target.files?.[0])} data-testid={`classe-foto-input-${s}`} />
          <div className="mt-4 pt-4 border-t">
            <Label className="text-xs block mb-1">Immagine Home (scorrimento pagina iniziale, orizzontale)</Label>
            {f.home_foto_id ? (
              <img src={publicFile(f.home_foto_id)} alt="Immagine Home" className="w-full aspect-[16/7] object-cover rounded-lg mb-2" data-testid={`classe-home-preview-${s}`} />
            ) : (
              <p className="text-xs text-muted-foreground mb-2">Non ancora caricata.</p>
            )}
            <Input type="file" accept=".jpg,.jpeg,.png,.webp" onChange={(e) => upload(e.target.files?.[0], "home")} data-testid={`classe-home-input-${s}`} />
          </div>
        </div>
        <div className="space-y-4">
          <h3 className="font-heading text-2xl uppercase">{f.categoria}</h3>
          <div><Label>Descrizione</Label><Textarea rows={3} value={f.descrizione || ""} onChange={(e) => setF({ ...f, descrizione: e.target.value })} data-testid={`classe-descrizione-${s}`} /></div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
            {FIELDS.map(([k, l]) => (
              <div key={k}><Label className="text-xs">{l}</Label><Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`classe-${k}-${s}`} /></div>
            ))}
          </div>
          <Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid={`classe-save-${s}`}>Salva {f.categoria}</Button>
        </div>
      </div>
    </Panel>
  );
};

export const ClassiAdmin = () => {
  const [classi, setClassi] = useState(null);
  useEffect(() => {
    api.get("/public/classi").then((r) => setClassi(r.data));
  }, []);
  if (!classi) return null;
  return (
    <div className="space-y-6">
      <p className="text-sm text-muted-foreground">Schede mostrate nella pagina iniziale pubblica. I dati tecnici precompilati sono indicativi: verificali e aggiornali se necessario.</p>
      {classi.map((c) => <ClasseForm key={c.categoria} classe={c} />)}
    </div>
  );
};
